// shared/application/useFotosProductores.js  (fotos decorativas por uuid de cuenta). Sin JSX ni Swal.
import { useEffect, useRef, useState } from 'react';
import { productoresRepository } from '../infrastructure/productores.repository';

const LIMITE_CONCURRENCIA = 4;

/**
 * `cuentaUuids`: uuids de cuenta visibles. Solo consulta los nuevos; dedupe; máx. 4 peticiones en paralelo.
 * Contrato: { fotos: { [uuid]: string | null | undefined } }  (undefined = cargando; null = sin foto).
 * La foto es decorativa: el repositorio no lanza y aquí tampoco se expone error.
 */
export const useFotosProductores = (cuentaUuids = [], { repository = productoresRepository } = {}) => {
  const [fotos, setFotos] = useState({});
  const mounted = useRef(true);
  const pedidos = useRef(new Set());
  const cola = useRef([]);
  const activos = useRef(0);
  const repoRef = useRef(repository);
  repoRef.current = repository;

  useEffect(() => {
    mounted.current = true;
    const pendientes = cola;
    return () => {
      mounted.current = false;
      pendientes.current = [];
    };
  }, []);

  const clave = [...new Set((cuentaUuids || []).filter(Boolean))].sort().join('|');

  useEffect(() => {
    const drenar = () => {
      while (activos.current < LIMITE_CONCURRENCIA && cola.current.length) {
        const uuid = cola.current.shift();
        activos.current += 1;
        Promise.resolve()
          .then(() => repoRef.current.fotoProductor(uuid))
          .catch(() => null)
          .then(url => {
            activos.current -= 1;
            if (mounted.current) setFotos(prev => ({ ...prev, [uuid]: url || null }));
            drenar();
          });
      }
    };
    clave
      .split('|')
      .filter(Boolean)
      .forEach(uuid => {
        if (pedidos.current.has(uuid)) return;
        pedidos.current.add(uuid);
        cola.current.push(uuid);
      });
    drenar();
  }, [clave]);

  return { fotos };
};

export default useFotosProductores;
